import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../supabaseClient'

export default function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession()

      if (!session) {
        navigate('/login')
        return
      }

      const userId = session.user.id

      const { data: workerRecord } = await supabase.from('workers').select('id').eq('id', userId).single()
      const { data: employerRecord } = await supabase.from('employers').select('id').eq('id', userId).single()

      if (employerRecord) {
        navigate('/employer/dashboard')
      } else if (workerRecord) {
        navigate('/worker/dashboard')
      } else {
        const user = session.user
        // Google's OAuth profile (via Supabase) doesn't reliably include separate
        // given_name/family_name fields -- it provides a single `full_name`/`name`.
        // Prefer given_name/family_name if present, otherwise split the full name.
        const meta = user.user_metadata || {}
        const fullName = meta.full_name || meta.name || ''
        const [firstFromFull, ...restFromFull] = fullName.trim().split(/\s+/).filter(Boolean)
        const firstName = meta.given_name || firstFromFull || ''
        const lastName  = meta.family_name || restFromFull.join(' ') || ''

        await supabase.from('workers').insert({
          id: userId,
          first_name: firstName,
          last_name: lastName,
          email: user.email
        })
        navigate('/worker/signup/personal')
      }
    }

    checkUser()
  }, [navigate])

  return (
    <div style={{background: '#0D1B2A', height: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <div style={{color: '#F5A623', fontFamily: 'sans-serif', fontSize: '16px'}}>Loading your profile...</div>
    </div>
  )
}
